export const isPhone = window.innerWidth <= 600;
